import React from "react";

const Header: React.FC = () => {
  return (
    <header className="bg-zinc-950 p-4 text-white text-center">
      <h1 className="text-2xl font-bold">Kanban board (Drag & drop)</h1>
    </header>
  );
};

export default Header;
